/* eslint-disable max-len */
import React, { useContext,useState } from 'react';
import CustomOverLay from '../CustomOverLay';
import GlobalContext from '../Context/GloablContext';
import { useGetOtpPreferenceListQuery ,useDeleteOtpPreferenceMutation} from '../../features/otpPrefrence';
import { motion } from 'framer-motion';
import AnimatedModel from '../Animation/AnimatedModel';
import ConfirmationPrompt from '../ConfirmationPrompt';
import formatMobileNumber from '../../CommonMethods/FormatMobileNumber'
import EmptyScreenOtp from '../Emptyscreenwithouttitle/otppreferenceemptyscreen';

export default function OtpPreferenceList({ username }) {
    const { setToastmessage, setToastErrorMessage, isSideBar } = useContext(GlobalContext);
    // Fetching the OTP preference data
    const { data: apiData, isFetching, status ,refetch} = useGetOtpPreferenceListQuery(username);
    const [deleteOtpPreference]=useDeleteOtpPreferenceMutation()
    const [hoverProperties,setHoverProperties] = useState({
        'hover':'',
        'hover_index':'',
        'index_to_display_modal':''
    })
    const [deletePreferenceModal, setDeletePreferenceModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [selectedId, setSelectedId] = useState(null); 

    // Safely accessing the OTP preferences array from the API response
    const safeData = Array.isArray(apiData?.data) ? apiData.data : [];
    
    // open delete modal
    const openDeleteModal = (id) => {
        setSelectedId(id);  // Set the selected ID for deletion
        setDeletePreferenceModal(true);  // Open modal
    };


    // handle delete function
    const handleDeletePreferences = async () => {
        if (!selectedId) return;  // Ensure selectedId exists
        setDeleteLoading(true);
        try {
            const res = await deleteOtpPreference(selectedId);  // Pass the selected ID directly here
            if (res?.error?.data?.message) {
                setToastErrorMessage('Error while deleting mode of preference');
            } else {
                setToastmessage('Mode of preference deleted successfully');
                refetch()
            }
        } catch (error) {
            console.error('Delete error', error);
            setToastErrorMessage('Error while deleting mode of preference');
        } finally {
            setDeleteLoading(false);
            setDeletePreferenceModal(false);
            setSelectedId(null);  // Reset the selected ID
        }
    };
    
    return (
        <>
            <div className="flex items-center my-[20px]">
                <p className="text-xl font-normal text-[#000000]">OTP Preference List</p>
            </div>
            {isFetching && status !== "fulfilled" ? (
                <CustomOverLay Active text="Loading Preference List..." classKey={`top-0 left-0 right-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_overlay2' : 'overlay-list2'}`} />
            ) : (
                <div className="border border-[#EDD7E1] rounded overflow-auto scrollBar-hidden mt-3.5 mb-5 pb-2">
                    {safeData.length > 0 ?(
                        <table aria-label="Outside Table" className="w-full table-auto">
                            <thead>
                                <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm">
                                    <th id="id" className="px-3 py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Email Address</span>
                                    </th>
                                    <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number</span>
                                    </th>
                                    <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">OTP Preference Mode</span>
                                    </th>
                                    <th id='action' className="px-3 py-2 rounded-tr-[2px] rounded-br-[2px] bg-[#EDD7E1] max-w-[245px] sticky right-0 pl-[92px]">
                                        <span className="flex items-center justify-center text-end text-sm font-normal text-[#000000]">Action</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {safeData.map((item, index) => (
                                    <tr key={index} className={`hover:bg-[#F8EEF1] h-[45px] table-tr`}>
                                        <td id='preferencevalue' className="px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                                            {item.otp_preference_mode === 'email' ? item.preference : '-'}
                                        </td>
                                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">
                                            {(item.otp_preference_mode === 'text' || item.otp_preference_mode === 'voice') ? `${item.country_code} ${formatMobileNumber(item.preference)}` : '-'}
                                        </td>
                                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">
                                            {item.otp_preference_mode === 'email' ? "Email" : item.otp_preference_mode === 'text' ? "Text" : "Voice"}
                                        </td>
                                        <td className={`px-8 py-2 text-sm text-end font-normal sticky right-0 max-w-[245px] text-[#031624] rounded-tr-[2px] rounded-br-[2px] min-w-[50px] last-td `}>  
                                            <div className="flex justify-center "> 
                                                <div onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'modify',hover_index:index}))}} 
                                                    onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}} className="px-8  min-w-[200px]">
                                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation))?<>
                                                        <motion.div
                                                            initial={{ opacity: 1, x: 0,y:0 }}
                                                            animate={{ opacity: 1, x: -45 ,y:0}}
                                                            transition={{ delay: 0.2, duration: 0.5 }}
                                                            exit={{ opacity: 0.5 }}
                                                            className=''
                                                        >
                                                            <button  
                                                                onClick={()=>{openDeleteModal(item._id)}}
                                                                                                
                                                            > 
                                                                <img  data-testid="delete-icon"  src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>
                                                        </motion.div>                  
                                                    </>:<button 
                                                        onClick={() => openDeleteModal(item._id)}
                                                        id={index+'pref_remove'}
                                                       
                                                    > 
                                                        <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>}                 
                                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation)) &&
                                                    <motion.div
                                                        initial={{ opacity: 0, x: 0,y:0 }}
                                                        animate={{ opacity: 1, x: 0 ,y:0}}
                                                        transition={{ delay: 0.2, duration: 0.5 }}
                                                        exit={{ opacity: 0.5 }}
                                                        className=''
                                                    >                 
                                                        <div className='relative ml-5 cursor-pointer mt-[-25px]' onClick={()=>{openDeleteModal(item._id)}} >                                   
                                                            <p  data-testid="delete-pref"   className="text-sm ml-10  font-normal text-[#972E4C] ">Delete</p>                                 
                                                        </div>
                                                    </motion.div>                             
                                                    }                    
                                                </div>         
                                            </div> 
                                        </td>  
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )
                        : (
                            <EmptyScreenOtp FirstPTag={"No OTP preferences added yet"} />
                        )
                    }
                </div>
            )}
            {deletePreferenceModal && (
                <AnimatedModel 
                    key="delete-model"
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleDeletePreferences}  // Pass the function directly without argument
                            handleClose={() => { setDeletePreferenceModal(false); setSelectedId(null); }}  // Clear selected ID on close
                            tittle={'Delete'}
                            data-testid="delete-pref-btn"
                            disabled={deleteLoading}
                            message={'Are you sure you want to delete this mode of preference?'}
                            buttonName={`Delete`}
                            loadingActivation={deleteLoading}
                        />
                    }
                />
            )}
        </>
    );
}
